import type { KnownLadderTierKey, LadderTierKey } from "./types";

import {
  TierBrilliant,
  TierBronze,
  TierElite,
  TierGold,
  TierPlatinum,
  TierSilver,
} from "../Icons";

/**
 * Badge artwork per ladder tier, keyed by the tier's ladder `key`.
 *
 * Keying by `key` rather than `tierRank` is deliberate: ranks are
 * region-relative (LATAM Bronze is rank 3, HK/REST Bronze is rank 1, TH/VN
 * Bronze is rank 2), so a rank-keyed map renders the wrong badge for most
 * regions. Because the map is a total `Record<KnownLadderTierKey, …>`, adding a
 * named tier is a compile error until its badge exists. Tiers outside the map
 * (e.g. numbered "Tier 1") have no artwork and get none — never another tier's.
 */
export const TIER_BADGE: Record<KnownLadderTierKey, string | { src: string }> =
  {
    bronze: TierBronze,
    silver: TierSilver,
    gold: TierGold,
    platinum: TierPlatinum,
    brilliant: TierBrilliant,
    elite: TierElite,
  };

export const tierBadgeFor = (
  key: LadderTierKey | null,
): string | { src: string } | undefined =>
  key !== null && Object.hasOwn(TIER_BADGE, key)
    ? TIER_BADGE[key as KnownLadderTierKey]
    : undefined;
